import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import Tilt from "react-parallax-tilt";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import serviceData from "./serviceData"; // Import your service details

gsap.registerPlugin(ScrollTrigger);

const Services = () => {

  const sectionRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      sectionRef.current,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 1.5,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      }
    );
  }, []);
  return (
    <div ref={sectionRef} className="bg-white py-20">
      <div className="container max-w-7xl mx-auto px-6">
        <motion.h3
          className="text-4xl font-semibold font-serif text-center text-yellow-600 mb-12"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          Our Portfolio of Services
        </motion.h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {serviceData.map((service, index) => (
            <Tilt key={index} tiltMaxAngleX={15} tiltMaxAngleY={15} glareEnable={true} glareColor="rgba(255, 255, 255, 0.1)">
              <motion.div
                className="relative overflow-hidden h-80  p-6 transition-transform duration-500 hover:scale-110 rounded-lg shadow-lg border-2 border-gray-300 text-white text-center transition duration-500 hover:border-yellow-600 backdrop-blur-md bg-opacity-20"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-40 object-cover rounded-md mb-4 transition-transform duration-500 hover:scale-110"
                />
                <h4 className="text-xl text-black font-semibold mb-2">{service.title}</h4>
                <p className="text-gray-800 text-sm">{service.description}</p>
              </motion.div>
            </Tilt>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
